#import "../fragments/wf-form-stub-fragment.graphql"

mutation IgnoreForm($input: ConnectedFormIgnoreInput!) {
    connectedFormIgnore(input: $input) {
        connectedForm {
            ...WfFormStubFragment
        }
    }
}
